module.exports = __webpack_public_path__ + "static/media/recent-pledged.c032fa12.svg";